import { bl_fi_sub_ledger_hdr_RowClass } from '../../../dbschema/bl_fi_sub_ledger_hdr.model';
//import { bl_fi_sub_ledger_line_RowClass } from '../../../dbschema/bl_fi_sub_ledger_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class SubledgerContainerModel extends BaseContainerModel {
  bl_fi_sub_ledger_hdr: bl_fi_sub_ledger_hdr_RowClass = new bl_fi_sub_ledger_hdr_RowClass();
}
